import React from 'react'
import { ImageProp } from '../../../../common/props'
import { SlideContainer } from './style'
import { useLaunchModalContext } from '../../../../contexts/LaunchModalContext'
import { MediaContainer } from '../../../../common/components/MediaContainer'

const CarouselSlides: React.VFC<{
  image: ImageProp
  index: number
}> = ({ image, index }) => {
  const { activeIndex, slidesLength } = useLaunchModalContext()
  return (
    <SlideContainer key={index} isActive={activeIndex === index} isFirstSlide={activeIndex === 0} isLastSlide={activeIndex === slidesLength - 1}>
      {image && <MediaContainer alt={image.altText} src={image.link} />}
    </SlideContainer>
  )
}

export default CarouselSlides
